export default {
    username: "",
    userData: null,
    userJobDetails: null
}
